module.exports = __webpack_public_path__ + "img/parrilla.e3984cbc.svg";